let _t: ((key: string, params?: any) => string) | null = null;
let _te: ((key: string) => boolean) | null = null;

export function setTranslator(t: (key: string, params?: any) => string, te?: (key: string) => boolean) {
	_t = t;
	_te = te || (() => false);
}

export function translate(key: string, params?: any): string {
	if (_t) return _t(key, params);

	return key;
}

export function exists(key: string): boolean {
	if (_te) return _te(key);

	return false;
}
